var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconActionHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "icon-action-home_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.011765 0 0 0 0 0.435294 0 0 0 0 0.886275 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -6)",
    filter: "url(#icon-action-home_svg__a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 12.19l5 4.5v7.81h-2v-6h-6v6h-2v-7.81l5-4.5zm0-2.69l-10 9h3v8h6v-6h2v6h6v-8h3l-10-9z",
    fill: "#2C3032"
  }))));
}

export default __webpack_public_path__ + "61bb4f40064f15d3580cefced8ee2e44.svg";
export { SvgIconActionHome as ReactComponent };